// @ts-check
import React from 'react';
import { PlainSelectField } from 'shared/containers/portal_layout/HForm';

const LocationField = ({ options, value }) => (
  <PlainSelectField name="locationId" label="Location" options={options} value={value} />
);

LocationField.displayName = 'LocationField';

export default LocationField;
